export default __webpack_public_path__ + "static/media/drag-and-drop.8040ef0b.svg";